export type CacheParams = Required<Pick<RequestConfig, 'responseType'>> &
  Pick<IRequestConfigCaching, 'lifetime' | 'cacheQueryOptions'>;

export enum CustomResponseHeaders {
  Date = 'date'
}
